export const creatorWorld = {
  title: "Creator World",
  subtitle: "Welcome to the Creator's world!",
  welcomeMessage: "Here you'll find everything your subscription includes",
  
  navigation: {
    products: "Products",
    events: "Events", 
    subscriptions: "Subscriptions",
    polls: "Polls",
    giveaways: "Giveaways",
    promoCodes: "Promo Codes",
    challenges: "Challenges",
    exclusiveContent: "Exclusive Content",
    profile: "My Profile"
  },

  gamification: {
    level: "Level",
    points: "Points",
    badges: "Badges",
    streak: "Streak",
    nextLevel: "Next level",
    pointsToNext: "points to next level",
    achievements: "Achievements",
    leaderboard: "Leaderboard"
  },

  stats: {
    totalPurchases: "Total Purchases",
    eventsAttended: "Events Attended",
    pollsVoted: "Polls Voted",
    challengesCompleted: "Challenges Completed",
    contentViewed: "Content Viewed",
    loyaltyPoints: "Loyalty Points"
  },

  products: {
    title: "Available products and services",
    subtitle: "Discover the exclusive offerings",
    buyNow: "Buy Now",
    learnMore: "Learn More",
    exclusive: "Exclusive",
    newArrival: "New",
    popular: "Popular"
  },

  events: {
    title: "Events and meetups",
    subtitle: "Join community events",
    upcoming: "Upcoming events",
    past: "Past events",
    joinEvent: "Join Event",
    eventFull: "Event Full",
    eventDate: "Date",
    eventLocation: "Location",
    attendees: "Attendees"
  },

  polls: {
    title: "Active polls",
    subtitle: "Share your opinion",
    vote: "Vote",
    voted: "Voted",
    results: "Results",
    endsIn: "Ends in",
    totalVotes: "total votes"
  },

  giveaways: {
    title: "Giveaways",
    subtitle: "Participate and win amazing prizes",
    participate: "Participate",
    participated: "Participating",
    prize: "Prize",
    participants: "participants",
    endsIn: "Ends in",
    winner: "Winner",
    drawDate: "Draw date"
  },

  promoCodes: {
    title: "My promo codes",
    subtitle: "Use your exclusive discounts",
    code: "Code",
    discount: "Discount", 
    validUntil: "Valid until",
    copyCode: "Copy Code",
    copied: "Copied!",
    useCode: "Use Code"
  },

  challenges: {
    title: "Challenges",
    subtitle: "Complete tasks and earn points",
    daily: "Daily challenges",
    weekly: "Weekly challenges",
    monthly: "Monthly challenges",
    completed: "Completed",
    inProgress: "In Progress",
    notStarted: "Not Started",
    reward: "Reward",
    complete: "Complete",
    progress: "Progress"
  },

  exclusiveContent: {
    title: "Exclusive content",
    subtitle: "Content available only for subscribers",
    watchNow: "Watch Now",
    downloadNow: "Download Now",
    newContent: "New Content",
    duration: "Duration",
    size: "Size",
    type: "Type"
  },

  profile: {
    title: "My Profile",
    memberSince: "Member since",
    subscription: "Subscription",
    status: "Status",
    nextBilling: "Next billing",
    manageSubscription: "Manage Subscription",
    preferences: "Preferences",
    notifications: "Notifications",
    privacy: "Privacy"
  },

  notifications: {
    newContent: "New content has arrived!",
    newEvent: "New event has been added!",
    newChallenge: "A new challenge awaits you!",
    giveawayWinner: "Congratulations! You won the giveaway!",
    levelUp: "Level up! You reached level {level}!",
    badgeEarned: "You earned a new badge!"
  },

  badges: {
    earlyBird: "Early Bird",
    socialButterfly: "Social Butterfly", 
    contentKing: "Content King",
    challengeMaster: "Challenge Master",
    loyalFan: "Loyal Fan",
    pollExpert: "Poll Expert",
    eventAttendee: "Event Attendee",
    firstPurchase: "First Purchase"
  }
};